export default "__VITE_ASSET__tFNgE_5r__"